import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=164ad2c1&scoped=true&"
import script from "./TwoFactor.vue?vue&type=script&lang=js&"
export * from "./TwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ad2c1",
  null
  
)

export default component.exports